import React from "react";
import Nprogress from "nprogress";
import ReactPlaceholder from "react-placeholder";
import "nprogress/nprogress.css";
import "react-placeholder/lib/reactPlaceholder.css";

export default function asyncComponent(importComponent) {
  class AsyncFunc extends React.Component {
    constructor(props) {
      super(props);
      this.state = {
        component: null,
        mounted: false,
      };
    }

    componentWillMount() {
      Nprogress.start();
    }

    componentWillUnmount() {
      this.setState({ mounted: false });
    }

    async componentDidMount() {
      this.setState({ mounted: true });
      const { default: ImportedComponent } = await importComponent();
      Nprogress.done();
      if (this.state.mounted && ImportedComponent) {
        this.setState({
          component: <ImportedComponent {...this.props} />,
        });
      }
    }

    render() {
      const ImportedComponent = this.state.component || <div />;
      return (
        <ReactPlaceholder
          type="text"
          rows={7}
          ready={ImportedComponent !== null}
        >
          {ImportedComponent}
        </ReactPlaceholder>
      );
    }
  }
  return AsyncFunc;
}
